let reactSlickPromise;
let reactImageGalleryPromise;

export function loadReactSlick() {
  if (!reactSlickPromise) {
    reactSlickPromise = Promise.all([
      import('react-slick').then((m) => m?.default || m),
      import('slick-carousel/slick/slick.css'),
    ]).then(([SliderComponent]) => SliderComponent);
  }

  return reactSlickPromise;
}

export function loadReactImageGallery() {
  if (!reactImageGalleryPromise) {
    reactImageGalleryPromise = Promise.all([
      import('react-image-gallery').then((m) => m?.default || m),
      import('react-image-gallery/styles/css/image-gallery.css'),
    ]).then(([ImageGalleryComponent]) => ImageGalleryComponent);
  }

  return reactImageGalleryPromise;
}
